"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveSectionToCookbookMutationOptions = exports.moveSectionToCookbook = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const sectionsByCookbookId_1 = require("../queries/sectionsByCookbookId");
exports.moveSectionToCookbook = client_1.gql `
  mutation MoveSectionToCookbook($input: MoveSectionToCookbook!) {
    moveSectionToCookbook(input: $input) {
      ok
    }
  }
`;
exports.moveSectionToCookbookMutationOptions = (variables, section, currentCookbookId) => ({
    variables,
    update: (store, { data: dataResponse }) => {
        if (!dataResponse) {
            return;
        }
        updateQuery_1.updateQuery(store, sectionsByCookbookId_1.sectionsByCookbookIdQuery, x => {
            x.sectionsByCookbookId = x.sectionsByCookbookId.filter(y => y.id !== variables.input.sectionId);
        }, { cookbookId: currentCookbookId });
        updateQuery_1.updateQuery(store, sectionsByCookbookId_1.sectionsByCookbookIdQuery, x => {
            x.sectionsByCookbookId.push(Object.assign(Object.assign({}, section), { position: -1 }));
        }, {
            cookbookId: variables.input.cookbookId,
        });
    },
});
//# sourceMappingURL=moveSectionToCookbook.js.map